import React from "react";
import commonFunctions from "../../common/Functions";

const SummaryCards = ({ 
  type,
  cumulativeData, 
  userBalance, 
}) => {
  const renderInvoiceSummary = () => (
    <>
      <div className="summary-item">
        <h6 style={{ color: "#28a745" }}>Total Amount</h6>
        <div className="summary-value">
          {commonFunctions.CommaFormatted(cumulativeData.total.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: "#28a745" }}>Paid Invoices</h6>
        <div className="summary-value positive">
          {commonFunctions.CommaFormatted(cumulativeData.paid.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: "#ffc107" }}>Pending Invoices</h6>
        <div className="summary-value warning">
          {commonFunctions.CommaFormatted(cumulativeData.pending.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: "#007bff" }}>Payment Rate</h6>
        <div className="summary-value">
          {cumulativeData.total > 0 ? ((cumulativeData.paid / cumulativeData.total) * 100).toFixed(1) : 0}%
        </div>
      </div>
    </>
  );

  const renderTransactionSummary = () => (
    <>
      <div className="summary-item">
        <h6 style={{ color: "#007bff" }}>Total Volume</h6>
        <div className="summary-value">
          {commonFunctions.CommaFormatted(cumulativeData.total.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: "#28a745" }}>Total Income</h6>
        <div className="summary-value positive">
          {commonFunctions.CommaFormatted(cumulativeData.income.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: "#dc3545" }}>Total Expenses</h6>
        <div className="summary-value negative">
          {commonFunctions.CommaFormatted(cumulativeData.expense.toFixed(2))} {cumulativeData.currency}
        </div>
      </div>
      <div className="summary-item">
        <h6 style={{ color: userBalance.total >= 0 ? "#28a745" : "#dc3545" }}>Net Cash Flow</h6>
        <div className={`summary-value ${userBalance.total >= 0 ? 'positive' : 'negative'}`}>
          {commonFunctions.CommaFormatted(userBalance.total.toFixed(2))} {userBalance.currency}
        </div>
      </div>
    </>
  );

  return (
    <div className="summary-cards">
      <h5>{type === 'invoices' ? 'Invoices' : 'Transactions'} Summary (All amounts converted to USD)</h5>
      <div className="summary-container mt-3">
        {type === 'invoices' ? renderInvoiceSummary() : renderTransactionSummary()}
      </div>
    </div>
  );
};

export default SummaryCards; 